const SiswaKelasParalel = {
    idSiswa: null,
    idKelas : null,
    namaSiswa: null,
    alamatSiswa: null,
    jenisKelamin: null,
    usernameSiswa: null,
    telponSiswa: null,    
    kodeTahunAjaran: null
};

export default SiswaKelasParalel;